import { Button, PageHeader } from 'components';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styles from './style.module.scss';
import { Tabs } from 'antd';
import { useNavigate } from 'hooks/useNavigate';
import { useEffect } from 'react';
import NotificationGroupsPages from './notificationGroups';
import PresentNotificationsPages from './presentNotifications';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../hooks/useUser';

const { TabPane } = Tabs;

const UsersNotificationPages = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const pages = useRecoilValue(getPage);

  function callback(key) {
    navigate(`/sso/notification/page/${key}`);
  }
  let btnLink = 'premisions/create/new';

  if (pathname.includes('page/role')) {
    btnLink = 'role/create/new';
  } else if (pathname.includes('page/notification-groups')) {
    btnLink = 'notification-groups/create/new';
  }
  const hideTabs = pathname.includes('edit-model');
  const hideCreateBtn = pathname.includes('present-notifications');
  useEffect(() => {
    if (
      !pathname.includes('/page/role') &&
      !pathname.includes('/page/premisions') &&
      !pathname.includes('/page/notification-groups') &&
      !pathname.includes('/page/present-notifications')
    ) {
      navigate('/sso/notification/page/notification-groups');
    }
  }, [pathname]);

  let defaultActiveKey = 'role';

  if (pathname.includes('/page/premisions')) {
    defaultActiveKey = 'premisions';
  }

  return (
    <div>
      {!hideTabs && (
        <PageHeader title={t('Notifiche').toUpperCase()}>
          {!hideCreateBtn && pages?.ability?.can_create && (
            <Link to={btnLink}>
              <Button width={'191px'} big icon={<PlusOutlined />}>
                {t('Crea')}
              </Button>
            </Link>
          )}
        </PageHeader>
      )}
      <div className={styles.container}>
        {!hideTabs && (
          <Tabs defaultActiveKey={defaultActiveKey} onChange={callback}>
            <TabPane tab='Gruppi notifiche' key='notification-groups' />
            <TabPane tab='Preset notifiche' key='present-notifications' />
          </Tabs>
        )}
        <Routes>
          <Route
            path={'/notification-groups/*'}
            element={<NotificationGroupsPages />}
          />
          <Route
            path={'/present-notifications/*'}
            element={<PresentNotificationsPages />}
          />
        </Routes>
      </div>
    </div>
  );
};

export default UsersNotificationPages;
